
import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';
import moment from 'moment'


@Component
class TimeService extends Vue {
    getAge(birthDate: string) {
        if(!birthDate) {
            return 0
        }
        const years = moment().diff(
            moment(birthDate, 'YYYY-MM-DD'),
            'years'
        )
        const months = moment().diff(
            moment(birthDate, 'YYYY-MM-DD'),
            'months'
        )
        if (years >= 1) {
            return years
        } else {
            return months === 0 ? 0.01 :  months / 100
        }
    }

    getPregnantSince(pregnancyDate: string) {
        if (!pregnancyDate) {
            return  0
          } else {
            const diffD = moment().diff(
              moment(pregnancyDate, 'YYYY-MM-DD'),
              'days'
            )
            if (diffD < 0) {
                return -1
            } else if(diffD < 16) {
                return 0.5
            } else {
              const diffM = diffD / 30
                const smaller05 = (diffD / 30) % 1 <= 0.5
                return smaller05 ? parseInt(diffM.toString()) : parseInt(diffM.toString()) + 0.5
            }
            /* cow.pregnantSince = moment(cow.pregnancyDate, 'YYYY-MM-DD').fromNow() */
          }
    }

    getPregnancyDate(pregnantSince: number|string) {
        const mesI = parseInt(pregnantSince.toString())
        const mesF = parseFloat(pregnantSince.toString())
  
        if (pregnantSince === 0) {
            return  null
          } else if (mesF % 1 === 0.5) {
            return  moment()
              .subtract(mesI, 'months')
              .subtract(15, 'days')
              .format('YYYY-MM-DD')
          } else {
            return moment()
              .subtract(mesI, 'months')
              .format('YYYY-MM-DD')
          }
    }

    getBirthDate(age: number|string) {
        if (age >= 1) {
            return moment()
              .subtract(age, 'years')
              .format('YYYY-MM-DD')
          } else {
            return moment()
              .subtract(parseFloat(age.toString()) * 100, 'months')
              .format('YYYY-MM-DD')
          }
    }

    getFemale(gender: string | number) {
      return gender === 'female' ? true: false
    }
}
export default TimeService;
